module.exports = __webpack_public_path__ + "img/permissions-selected.62e0ac62.svg";